import { useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../constants/constants";
import { useAuth0 } from "./react-auth0-spa";

const useRecoleccionAPI = (initialBody = {}) => {
  const [body, setBody] = useState(initialBody);
  const [data, setData] = useState(null);
  const [isLoadingRecoleccion, setIsLoading] = useState(false);
  const [isErrorRecoleccion, setIsError] = useState(false);
  const [errorRecoleccion, setErrorRecoleccion] = useState("");
  const { user, getTokenSilently } = useAuth0();

  useEffect(() => {
    setIsLoading(false);
    if (Object.keys(body).length === 0) return;
    const fetchData = async () => {
      try {
        setErrorRecoleccion("");
        const t = await getTokenSilently();
        const r = await axios.post(API_URL + `/recoleccion/${user.sub}`, body, {
          headers: {
            Authorization: `Bearer ${t}`,
          },
        });
        console.log(r);
        if (r.status === 202) {
          setErrorRecoleccion(r.data.message);
          setIsError(true);
        } else {
          setErrorRecoleccion("Generada");
          setIsError(false);
          setData(r.data);
        }
      } catch (error) {
        setErrorRecoleccion("Error en servidor");
        setIsError(true);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [body,getTokenSilently]);

  return [{ data, isErrorRecoleccion,isLoadingRecoleccion,errorRecoleccion }, setBody];
};

export default useRecoleccionAPI;
